/**
 * Types status effects (cf wiki §33.10 + Lot 19).
 * Aligne avec StatusEffectModel + EntityStatusEffectModel cote backend.
 */

export type StatusEffectTargetType = 'Planet' | 'Fleet' | 'Player';

export interface StatusEffectModel {
  id: number;
  code: string;
  label: string;
  order?: number;
  isBuff: boolean;
  effectData: string;
  durationSeconds?: number | null;
  imageCode?: string | null;
  created: string;
}

export interface EntityStatusEffectModel {
  id: number;
  targetType: StatusEffectTargetType;
  targetId: number;
  statusEffectId: number;
  startedAt: string;
  endsAt?: string | null;
  source?: string | null;
  sourceId?: number | null;
  created: string;
}

/** Reponse de GET /api/v1/EntityStatusEffect/active. */
export interface ActiveStatusEffectEntry {
  model: EntityStatusEffectModel;
  statusEffect: StatusEffectModel;
}

export interface ApplyStatusEffectPDTO {
  targetType: StatusEffectTargetType;
  targetId: number;
  code?: string | null;
  statusEffectId?: number | null;
  source?: string | null;
  sourceId?: number | null;
}

/** Parse l'effectData JSON (forme libre { atk_pct: +20, ... }). */
export function parseEffectData(s: string | null | undefined): Record<string, unknown> | null {
  if (!s) return null;
  try {
    return JSON.parse(s) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Formate une valeur de l'effectData en label lisible. */
export function formatEffectEntry(key: string, value: unknown): string {
  if (typeof value === 'boolean') return value ? key : `!${key}`;
  if (typeof value === 'number') {
    if (key.endsWith('_pct')) return `${value > 0 ? '+' : ''}${value}% ${key.replace(/_pct$/, '')}`;
    if (key.endsWith('_dot')) return `${value}/s ${key.replace(/_dot$/, '')}`;
    return `${value} ${key}`;
  }
  return `${key}=${String(value)}`;
}

/** Format duree restante en mm:ss / hh:mm:ss. */
export function formatRemaining(endsAt: string | null | undefined, now: number): string {
  if (!endsAt) return 'permanent';
  const ms = new Date(endsAt).getTime() - now;
  if (ms <= 0) return 'expire';
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
}
